import React, {useContext, useEffect} from "react";
import {NavLink, Route, Routes, useLocation, useNavigate} from "react-router-dom";
import AccountHome from "./account/AccountHome";
import AccountConnections from "./account/AccountConnections";
import {AuthContext} from "../../context/AuthContext";
import {doLogout} from "../../store/actions/UserActions";
import {useDispatch} from "react-redux";

const AccountIndex = () => {

    const {currentUser} = useContext(AuthContext);
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const doLogoutButton = () =>{
        dispatch(doLogout());
        navigate('/');
    }

    return (
        <div className="container account">
            <div className="hero-section-left">
                <div className="tag mt-0 left">ACCOUNT</div>
            </div>
            <div className="row">
                <div className="col-md-3">
                    <div className="profileSidebar">
                        <div className="profileDetails">
                            {/*<img src={currentUser?.profileImageUrl} alt="" className="headerProfileImage"/>*/}
                            <p>{currentUser?.displayName}</p>
                        </div>

                        <div className="profileButtons">
                            <button className="btn btn-danger" onClick={doLogoutButton}>Log out</button>
                        </div>
                    </div>
                </div>

                {/*<div className="col-md-9">*/}
                {/*    <div className="accountsNavigation">*/}
                {/*        <NavLink className="navItem" to="" end>MAIN</NavLink>*/}
                {/*        <NavLink className="navItem" to="connections" end>CONNECTIONS</NavLink>*/}
                {/*    </div>*/}
                {/*    <Routes location={location}>*/}
                {/*        <Route path="" element={<AccountHome/>}/>*/}
                {/*        <Route path="connections" element={<AccountConnections />} />*/}
                {/*    </Routes>*/}
                {/*</div>*/}
            </div>

        </div>
    );
}

export default AccountIndex;